import { createElement as e } from "react";
import { easySwitch } from "sc/helpers/switch";
import AnonymousRoutes from "./routes/Anonymous";
import AdminRoutes from "./routes/Admin";
import TechRoutes from "./routes/Tech";
import PartnerAdminRoutes from "./routes/PartnerAdmin";
import PartnerTechRoutes from "./routes/PartnerTech";

import { connect } from "react-redux";
import {
  role,
  ANONYMOUS,
  ADMIN,
  TECH,
  PARTNER_ADMIN,
  PARTNER_TECH,
} from "./selectors/auth";
import { withRouter } from "react-router";

export default withRouter(
  connect(
    (state, ownProps) => ({
      role: role(state),
    }),
    (dispatch, ownProps) => ({}),
  )(({ role }) => {
    const roleRoutes = easySwitch(role, {
      [ANONYMOUS]: () => AnonymousRoutes,
      [ADMIN]: () => AdminRoutes,
      [TECH]: () => TechRoutes,
      [PARTNER_ADMIN]: () => PartnerAdminRoutes,
      [PARTNER_TECH]: () => PartnerTechRoutes,
    });
    return e(
      "div",
      { className: "AppContainer container" },
      e("div", { id: "page-content", className: "container" }, e(roleRoutes)),
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/Routes.js